export default class AppTooltip {
    constructor () {
        this.init();
    }

    init () {
        $('[rel="tooltip"], [data-toggle="tooltip"]').tooltip({
            placement: 'left',
            container: 'body',
            trigger: 'hover',
        });
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/tootltip.js